"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = __importDefault(require("../../components/Text"));
const list_module_scss_1 = __importDefault(require("./list.module.scss"));
const List = ({ count, className, variant = 'primary', children }) => {
    return ((0, jsx_runtime_1.jsxs)("li", { className: (0, classnames_1.default)(className, list_module_scss_1.default.item), children: [(0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(list_module_scss_1.default.count, list_module_scss_1.default[`count_${variant}`]), children: (0, jsx_runtime_1.jsx)(Text_1.default, { as: "span", fontWeight: "medium", children: count }) }), (0, jsx_runtime_1.jsx)(Text_1.default, { as: "span", children: children })] }));
};
exports.default = List;
